import { render, staticRenderFns } from "./SignupStatusChip.vue?vue&type=template&id=4fb1941f"
import script from "./SignupStatusChip.vue?vue&type=script&lang=ts"
export * from "./SignupStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports